module.exports = __webpack_public_path__ + "static/media/topview.cddaf393.png";